// import packages
import React, { useContext } from "react";
import { LegacyCard as Card, TextField, Layout, BlockStack } from "@shopify/polaris";
import { Editor } from "@tinymce/tinymce-react";

// import constant
import constant from "lib/constant/constant";

// import contexts
import { PrivateContext } from "lib/context";
import { FormContext } from "../../../context/context";

const { TITLE = "" } = constant;

const TitleDescription = () => {
  const { handleTiny, data, handleChange, learnMore } = useContext(FormContext);
  const { cms } = useContext(PrivateContext);

  return (
    // <Layout.AnnotatedSection
    //   title={cms("section.form.section.information.title")}
    //   description={cms("section.form.section.information.description")}
    // >
    <Card
      title={cms("section.form.section.information.title")}
      id="productInformation"
      actions={[
        {
          content: cms("common.label.learnMore"),
          onAction: () => {
            learnMore("productInformation", cms("section.form.section.information.title"));
          },
        },
      ]}
    >
      <Card.Section>
        <BlockStack gap="2">{cms("section.form.section.information.description")}</BlockStack>
        <br />
        <TextField
          id="title"
          label={`${cms("section.form.section.information.label.title")}*`}
          value={data.title || ""}
          onChange={(value) => handleChange(TITLE, value)}
          placeholder={cms("section.form.section.information.placeholder.title")}
        />
        <br />
        {cms("section.form.section.information.label.description")}
        <Editor
          id="idTiny"
          textareaName="Description"
          value={data.tinyMCE}
          onEditorChange={handleTiny}
          init={{
            menubar: true,
            plugins: ["autolink link image lists print preview"],
            toolbar: "undo redo | bold italic | alignleft aligncenter alignright",
            entity_encoding: "raw",
          }}
        />
      </Card.Section>
    </Card>
    // </Layout.AnnotatedSection>
  );
};

export default TitleDescription;
